import Resource from './Resource';

export default class StudentData extends Resource {
	constructor(options={}) {
		let {
			route,
			routeParams = {},
			query = {},
			data = {}
		} = options;

		let config = {
			route: route,
			routeParams: routeParams,
			query: query,
			data: data,
		};

		super(config);
		return this;
	}

	get() {
		return this.request();
	}

	post() {
		return this.request('post');
	}
}
